// This is generated.  Alter it in blockGroups/forms/types/SubForm.js
/* eslint-disable no-unused-vars */
const Form = require('./Form');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context,
    parentAccessRestrictions,
  ) {
    return Form.asDataDictionary(hNode, context, parentAccessRestrictions);
  },
};
moduleRegistration.registerHNodeType('forms', 'SubForm', module.exports);
